import React from 'react';

import { Container } from 'reactstrap';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCopyright } from '@fortawesome/free-regular-svg-icons';

import 'bootstrap/dist/css/bootstrap.min.css';
import '../assets/App.css';


const Footer = () => {
    return (
        <footer className="footer">
            <Container>
                <p className="text-muted text-center" style={{ fontSize: '18px', marginBottom: '4px', marginTop: '2px' }}>
                    <FontAwesomeIcon icon={faCopyright} size='sm' inverse style={{ color: "var(--logo_1)" }} /> 2019 Gianmarco Verbana
                </p>
            </Container>
        </footer>
    );
};


export default Footer;